import styled from "styled-components"
import pointsTrophy from "../../../../media/points-trophy.svg"

// GameRules styles

export const Container = styled.div`
  position: relative;
  width: ${props => props.hasEvenlyRoundedCorners ? "75%" : "90%"};
  font-size: 90%;
  box-sizing: border-box;
  font-family: "The Sans", sans-serif;

  border-radius: ${props => props.hasEvenlyRoundedCorners ? "1rem" : "30px 250px 250px 30px"};
  background-color: ${props => props.bgColor};
  padding: 2% 0 0 2%;
  display: flex;
`
export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 100%;
  border-radius: 20px;
  padding: 0 1.2rem;
  padding-bottom: 2%;
  z-index: 1;

  img {
    width: 10vw;
  }
`
export const Header = styled.div`
  h1, h2 {
    color: ${({fontColor}) => fontColor}
  }
  margin: 0 0 2% 4%;
`
export const QuizTitle = styled.h1`
  font-weight: 500;
  margin: 0;
`
export const QuizTagline = styled.h2`
  font-weight: 200;
  margin: 0;
`
export const Content = styled.div`
  width: 100%;
  //& > * {
  //  padding-right: 33% !important; // So text doesn't go behind ModeLogo
  //}
`
export const ModeLogo = styled.img.attrs({
  src: pointsTrophy
})`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  padding-right: 0 !important;
  display: ${props => props.isVisible ? "block" : "none"}
`

// RulesList styles

export const RulesListContainer = styled.div`
  background-color: ${props => props.bgColor};
  color: ${props => props.fontColor};
  font-family: "The Sans", sans-serif;

  border-radius: ${props => props.hasEvenlyRoundedCorners ? "1rem" : "30px 30px 250px 30px"};
  padding: 2% 5%;
`
export const List = styled.ol`
  margin: 0;
  padding: 0.5% 0 0;
  list-style: none;
`
export const ListItem = styled.li`
    display: flex;
    margin-bottom: 0.5%;
`
export const Rule = styled.span``

export const GameMode = styled.h4`
  margin: 0;
`
export const Index = styled.span`
  display: inline-block;
  width: 6%;
  flex: 0 0 6%;
`
